"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverlayBanner = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _markdownToJsx = _interopRequireDefault(require("markdown-to-jsx"));

var _LinkButton = require("../buttons/LinkButton");

var _LinkExternalWithHref = require("../LinkExternalWithHref");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable id-length */
var OverlayBanner = function OverlayBanner(_ref) {
  var message = _ref.message,
      buttonText = _ref.buttonText,
      cashbotName = _ref.cashbotName,
      onClick = _ref.onClick,
      doFocus = _ref.doFocus,
      openLinksInNewTab = _ref.openLinksInNewTab;
  var buttonProps = {
    cashbotName: cashbotName,
    onClick: onClick,
    doFocus: doFocus,
    cssClass: "overlay-button btn-link"
  };
  var overrides = {};

  if (openLinksInNewTab) {
    overrides.overrides = {
      a: _LinkExternalWithHref.LinkExternalWithHref
    };
  }

  return _react.default.createElement("div", {
    className: "overlay-banner"
  }, _react.default.createElement("div", {
    className: "overlay-banner-container"
  }, _react.default.createElement(_markdownToJsx.default, {
    className: "overlay-message",
    options: overrides
  }, message), _react.default.createElement(_LinkButton.LinkButton, buttonProps, buttonText)));
};

exports.OverlayBanner = OverlayBanner;
OverlayBanner.defaultProps = {
  doFocus: false,
  openLinksInNewTab: false
};
OverlayBanner.propTypes = {
  message: _propTypes.default.string.isRequired,
  buttonText: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired,
  doFocus: _propTypes.default.bool,
  openLinksInNewTab: _propTypes.default.bool
};